exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tasksRegisterModal .v--modal-box.v--modal{min-height:460px!important;min-width:750px!important}#tasksRegisterModal .modal__content{overflow-y:hidden!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8e8c7f50","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/tasks/modals/TasksRegister.vue
// module id = 2122
// module chunks = 0